<template>
  <div class="container" :key="updateComponent">
    <h1 class="page-title">Endpoint Settings</h1>
    <!-- GAC Endpoint -->
    <div class="form-section">
      <h3>GAC Endpoint</h3>
      <form @submit.prevent="saveEndpoint()">
        <div class="form-row">
          <label for="gac-localhost">Local Host:</label>
          <input
            type="text"
            v-model="gac_localhost_endpoint"
            id="gac-localhost"
            :class="gac == gac_localhost_endpoint ? 'active' : ''"
            style="width: 300px"
            class="text-input"
            required
          />
          <div>
            <button type="submit" class="form-button">Set</button>
            <button
              type="button"
              @click.prevent="useState('gac_local')"
              class="form-button"
            >
              Use
            </button>
          </div>
        </div>
      </form>
      <form @submit.prevent="saveEndpoint()">
        <div class="form-row">
          <label for="gac-live-url">Live URL:</label>
          <input
            type="text"
            v-model="gac_live_endpoint"
            id="gac-live-url"
            style="width: 300px"
            :class="gac == gac_live_endpoint ? 'active' : ''"
            class="text-input"
            required
          />
          <div>
            <button type="submit" class="form-button">Set</button>
            <button
              type="button"
              @click.prevent="useState('gac_live')"
              class="form-button"
            >
              Use
            </button>
          </div>
        </div>
      </form>
    </div>

    <!-- Budget Endpoint -->
    <div class="form-section">
      <form @submit.prevent="saveEndpoint()">
        <h3>Budget Endpoint</h3>
        <div class="form-row">
          <label for="budget-localhost">Local Host:</label>
          <input
            type="text"
            v-model="budget_local_endpoint"
            id="budget-localhost"
            style="width: 300px"
            class="text-input"
            :class="budget == budget_local_endpoint ? 'active' : ''"
            required
          />
          <div>
            <button type="submit" class="form-button">Set</button>
            <button
              type="button"
              @click.prevent="useState('budget_local')"
              class="form-button"
            >
              Use
            </button>
          </div>
        </div>
      </form>

      <form @submit.prevent="saveEndpoint()">
        <div class="form-row">
          <label for="budget-live-url">Live URL:</label>
          <input
            type="text"
            v-model="budget_live_endpoint"
            id="budget-live-url"
            style="width: 300px"
            :class="budget == budget_live_endpoint ? 'active' : ''"
            class="text-input"
            required
          />
          <div>
            <button type="submit" class="form-button">Set</button>
            <button
              type="button"
              @click.prevent="useState('budget_live')"
              class="form-button"
            >
              Use
            </button>
          </div>
        </div>
      </form>
    </div>

    <!-- MPR Endpoint -->
    <div class="form-section">
      <form @submit.prevent="saveEndpoint()">
        <h3>MPR Endpoint</h3>
        <div class="form-row">
          <label for="mpr-localhost">Local Host:</label>
          <input
            type="text"
            v-model="mpr_local_endpoint"
            id="mpr-localhost"
            style="width: 300px"
            :class="mpr == mpr_local_endpoint ? 'active' : ''"
            class="text-input"
            required
          />
          <div>
            <button type="submit" class="form-button">Set</button>
            <button
              type="button"
              @click.prevent="useState('mpr_local')"
              class="form-button"
            >
              Use
            </button>
          </div>
        </div>
      </form>

      <form @submit.prevent="saveEndpoint()">
        <div class="form-row">
          <label for="mpr-live-url">Live URL:</label>
          <input
            type="text"
            v-model="mpr_live_endpoint"
            id="mpr-live-url"
            style="width: 300px"
            :class="mpr == mpr_live_endpoint ? 'active' : ''"
            class="text-input"
            required
          />
          <div>
            <button type="submit" class="form-button">Set</button>
            <button
              type="button"
              @click.prevent="useState('mpr_live')"
              class="form-button"
            >
              Use
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script setup>
import { onMounted, ref } from "vue";
import Swal from "sweetalert2";

const gac_localhost_endpoint = ref("http://localhost");
const gac_live_endpoint = ref("https://ccs.suburbanfiberco.com");
const budget_local_endpoint = ref("http://localhost");
const budget_live_endpoint = ref("https://expenditure.legend.ng");
const mpr_local_endpoint = ref("http://localhost");
const mpr_live_endpoint = ref("https://expenditure.legend.ng");
const gac = ref("http://localhost");
const budget = ref("http://localhost");
const mpr = ref("http://localhost");
const updateComponent = ref(0);

// Define a reactive settings object
const settings = ref({
  defaultStates: [
    {
      gac: gac_localhost_endpoint.value,
      budget: budget_local_endpoint.value,
      mpr_local: mpr_local_endpoint.value,
    },
  ],
  env: [
    {
      gac_live: gac_live_endpoint.value,
      gac_local: gac_localhost_endpoint.value,
      budget_live: budget_live_endpoint.value,
      budget_local: budget_local_endpoint.value,
      mpr_live: mpr_live_endpoint.value,
      mpr_local: mpr_local_endpoint.value,
    },
  ],
});

// This method will save the current endpoint settings to localStorage
const saveEndpoint = () => {
  // Update the settings object with the latest input values
  settings.value.env[0] = {
    gac_live: gac_live_endpoint.value,
    gac_local: gac_localhost_endpoint.value,
    budget_live: budget_live_endpoint.value,
    budget_local: budget_local_endpoint.value,
    mpr_live: mpr_live_endpoint.value,
    mpr_local: mpr_local_endpoint.value,
  };

  updateComponent.value++;

  // Now, store the updated settings in localStorage
  localStorage.setItem("settings", JSON.stringify(settings.value));
  Swal.fire({
    title: "Success!",
    text: "Endpoint Saved!",
    icon: "success",
    confirmButtonText: "Ok!",
  });
};

// This method will update the defaultStates with the selected state
const useState = (state) => {
  // Access the settings and update the state in defaultStates
  const stateValue = settings.value.env[0][state];

  if (stateValue) {
    // Update the corresponding endpoint with the state value
    if (state === "gac_local") {
      settings.value.defaultStates[0].gac = gac_localhost_endpoint.value;
      localStorage.setItem("settings", JSON.stringify(settings.value));
      Swal.fire({
        title: "Success!",
        text: "Endpoint Activated!",
        icon: "success",
        confirmButtonText: "Ok!",
      });
    } else if (state === "gac_live") {
      settings.value.defaultStates[0].gac = gac_live_endpoint.value;
      localStorage.setItem("settings", JSON.stringify(settings.value));
      Swal.fire({
        title: "Success!",
        text: "Endpoint Activated!",
        icon: "success",
        confirmButtonText: "Ok!",
      });
    } else if (state === "budget_local") {
      settings.value.defaultStates[0].budget = budget_local_endpoint.value;
      localStorage.setItem("settings", JSON.stringify(settings.value));
      Swal.fire({
        title: "Success!",
        text: "Endpoint Activated!",
        icon: "success",
        confirmButtonText: "Ok!",
      });
    } else if (state === "budget_live") {
      settings.value.defaultStates[0].budget = budget_live_endpoint.value;
      localStorage.setItem("settings", JSON.stringify(settings.value));
      Swal.fire({
        title: "Success!",
        text: "Endpoint Activated!",
        icon: "success",
        confirmButtonText: "Ok!",
      });
    } else if (state === "mpr_local") {
      settings.value.defaultStates[0].mpr = mpr_local_endpoint.value;
      localStorage.setItem("settings", JSON.stringify(settings.value));
      Swal.fire({
        title: "Success!",
        text: "Endpoint Activated!",
        icon: "success",
        confirmButtonText: "Ok!",
      });
    } else if (state === "mpr_live") {
      settings.value.defaultStates[0].mpr = mpr_live_endpoint.value;
      localStorage.setItem("settings", JSON.stringify(settings.value));
      Swal.fire({
        title: "Success!",
        text: "Endpoint Activated!",
        icon: "success",
        confirmButtonText: "Ok!",
      });
    }
  }

  window.location.reload();
};

onMounted(() => {
  // If settings are available in localStorage, load them
  const storedSettings = localStorage.getItem("settings");
  if (storedSettings) {
    settings.value = JSON.parse(storedSettings);

    // Update reactive values from the loaded settings
    gac_localhost_endpoint.value = settings.value.env[0].gac_local;
    gac_live_endpoint.value = settings.value.env[0].gac_live;
    budget_local_endpoint.value = settings.value.env[0].budget_local;
    budget_live_endpoint.value = settings.value.env[0].budget_live;
    mpr_local_endpoint.value = settings.value.env[0].mpr_local;
    mpr_live_endpoint.value = settings.value.env[0].mpr_live;

    gac.value = settings.value.defaultStates[0].gac;
    budget.value = settings.value.defaultStates[0].budget;
    mpr.value = settings.value.defaultStates[0].mpr;
  }
});
</script>

<style scoped>
/* Styling for the container */
.container {
  max-width: 100%;
  margin: 0 auto;
  /* padding: 20px; */
}

.page-title {
  font-size: 24px;
  margin-bottom: 20px;
}

.form-section {
  margin-bottom: 20px;
}

.form-row {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

label {
  width: 100px;
  font-weight: bold;
}

.text-input {
  padding: 5px;
  margin-right: 10px;
}

.form-button {
  padding: 5px 10px;
  background-color: #007bff;
  color: #fff;
  border: none;
  cursor: pointer;
  font-size: 14px;
  margin-right: 3px;
}

.form-button:hover {
  background-color: #0056b3;
}

/* Loader animation */
.loader {
  width: 10px;
  height: 10px;
  border: 2px solid black;
  border-bottom-color: transparent;
  border-radius: 50%;
  display: inline-block;
  animation: rotation 1s linear infinite;
}

.active {
  background: green;
  color: #fff;
}

@keyframes rotation {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
